"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.demDetCalculation = demDetCalculation;
exports.derateAndRefund = derateAndRefund;
exports.getElectricityCharge = getElectricityCharge;
exports.repairFeeDetail = repairFeeDetail;
exports.searchNew = searchNew;
var _request = _interopRequireDefault(require("@/utils/request"));
/**
 *修箱费用详细查询
 * @param query
 */
function repairFeeDetail(query) {
  return (0, _request.default)({
    url: '/equery/demurrage/getRepairDetail',
    method: 'post',
    params: query
  });
}

/**
 *退费减免进度查询
 * @param query
 */
function derateAndRefund(query) {
  return (0, _request.default)({
    url: '/equery/demurrage/getDerateAndRefund',
    method: 'post',
    params: query
  });
}

/**
 * 滞期费计算器
 * @param query
 */
function demDetCalculation(query) {
  return (0, _request.default)({
    url: '/equery/demurrage/calculation',
    method: 'post',
    params: query
  });
}

/**
 * 滞期费查询新版
 * @param query
 */
function searchNew(query) {
  return (0, _request.default)({
    url: '/equery/demurrage/searchNew',
    method: 'post',
    params: query
  });
}

/**
 * 插电费查询
 * @param query
 */
function getElectricityCharge(query) {
  return (0, _request.default)({
    url: '/equery/demurrage/getElectricityCharge',
    method: 'post',
    params: query
  });
}